import MainMenu from '@/Components/Menus/Main/MainMenu.jsx';
import * as React from 'react';
import {memo} from 'react';

const GuestMenu = () => {
    const items = [
        {
            id: 'welcome',
            text: 'Accueil',
            route: route('welcome'),
            variant: 'plain',
        },
        {
            id: 'login',
            text: 'Se connecter',
            route: route('login'),
            variant: 'contained',
            color: 'neutral',
        },
    ];

    return <MainMenu menuItems={items} />;
};

export default memo(GuestMenu);
